import { render, staticRenderFns } from "./ordersPendent.vue?vue&type=template&id=59263f44"
import script from "./ordersPendent.vue?vue&type=script&lang=js"
export * from "./ordersPendent.vue?vue&type=script&lang=js"
import style0 from "./ordersPendent.vue?vue&type=style&index=0&id=59263f44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports